// extracted by mini-css-extract-plugin
module.exports = {"legal":"az_cgb","headline":"az_dgb"};